<!--华伟刀闸页面-->
<template>
	<treeBody>
		<!--左边-->
		<virtualDeviceTree slot="tree" :dataList="deviceList" @checkItem="nowDevice = $event" :autoSelectMethod='autoSelectMethod'></virtualDeviceTree>
		<!--右边-->
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<multipleSelection title="变量类型" nameKey="name" :list='apptypeGroups' @checkDataList="nowApptypeGroups = $event"
				 :autoCheckIdList="nowSelectAppTypeGroupIds"></multipleSelection>
				<datePicker class="marginLeft" :initDate='bgDate' @checkDate="bgDate = $event" dateType="dateTime"></datePicker>
				<datePicker class="marginLeft" :initDate='endDate' @checkDate="endDate = $event" dateType="dateTime"></datePicker>
				<iconButton icoName="wedoButton/search.png" buttonText="查看" @buttonClick="searchKnifegate"></iconButton>
			</div>
			<!--图表-->
			<vchart style="height: calc(100% - 50px);" ref='vchart'></vchart>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import datePicker from '@/components/module/datePicker/base/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import dateButton from '@/components/module/universal/dateButton.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			virtualDeviceTree,
			treeBody,
			multipleSelection,
			datePicker,
			iconButton,
			dateButton,
			vchart,
		},
		props: {},
		data() {
			return {
				deviceList: [],
				nowApptypeGroups: [], //当前选中的应用类型组
				bgDate: new Date(new Date().formatByDate()),
				endDate: new Date(),
				nowSelectAppTypeGroupIds: [],
				options: {},
				nowDevice: undefined
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			//从静态资源中获取静态数
			this.deviceList = knifeGateCurveDefaultDeviceTree
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.yAxis = {
				lineStyle: {
					show: false,
					width: 1,
					type: 'solid',
				}
			}
			this.options.toolbox['iconStyle'] = {
				'color': 'white',
				'borderColor': 'white',
				'shadowColor': 'white'
			}
			this.options.tooltip = {
				trigger: 'axis',
				confine: true,
				formatter(params, ticket, callback) {
					var label = "第" + (params[0].data[0] + 1) + "毫秒</br>"
					for (var i = 0, len = params.length; i < len; i++) {
						label += params[i].seriesName + " : " + params[i].data[1] + "</br>"
					}
					return label;
				},
				axisPointer: {
					animation: false
				}
			}
			this.options.dataZoom = [{
					type: 'slider',
					show: true,
					start: 0,
					end: 1,
					handleSize: 8
				},
				{
					type: 'inside',
					start: 0,
					end: 1
				}
			]
			this.$refs.vchart.setData(this.options, true)
			setTimeout(() => {
				this.searchKnifegate()
			}, 2000)
		},
		destroyed() {},
		computed: {
			variableList() {
				//当前选中的设备的选择的应用类型组的变量列表
				if (isempty(this.nowApptypeGroups)) {
					return []
				}
				var list = []
				for (var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
					var item = this.nowApptypeGroups[i]
					list.addAll(item.next)
				}
				return list
			},
			apptypeGroups() {
				if (this.nowDevice == undefined) {
					return []
				}
				return knifeGateCurveDefaultDeviceNoToVariableTree[this.nowDevice.no]
			}
		},
		watch: {
			apptypeGroups(nv, ov) {
				if (nv.length > 0) {
					this.nowSelectAppTypeGroupIds = [nv[0].id]
				} else {
					this.nowSelectAppTypeGroupIds = []
				}
			},
			variableList(nv, ov) {

			}
		},
		methods: {
			autoSelectMethod(item, index) {
				return item.type == 'virtualDevice'
			},
			selectBgDate(date) {
				this.bgDate = date
			},
			selectEndDate(date) {
				this.endDate = date
			},
			searchKnifegate() {
				//先重置当前图形
				this.options.series = []
				this.options.legend.data = []
				this.options.legend.selected = {}
				this.$refs.vchart.setData(this.options, true)
				if (isempty(this.variableList)) {
					//没变量，返回
					return
				}
				this.$dialogMethod.showLoading('正在查询数据。。。')
				this.$api.knifegateApi.getDataList(this.variableList.map(item => item.name).join(","), this.bgDate.getTime(), this.endDate
					.getTime(), respon => {
						var selected = {}
						var legendData = []
						var keys = Object.keys(respon)
						var serList = []
						var dateBean = new Date()
						for (var i = 0, len = keys.length; i < len; i++) {
							var key = keys[i]
							var dataList = respon[key]
							for (var i1 = 0, len1 = dataList.length; i1 < len1; i1++) {
								var data = dataList[i1]
								dateBean.setTime(data.beginTime)
								var name = dateBean.formatByTime() + " -- " + key
								legendData.push({
									name: name,
									icon: 'roundRect'
								})
								selected[name] = serList.length > 20 ? false : true
								serList.push({
									name: name,
									type: 'line',
									large: true,
									sampling: 'average',
									data: data.dataList.split(',').map((item, index) => {
										return [index, item]
									})
								})
							}
						}
						this.options.series = serList
						this.options.legend.data = legendData
						this.options.legend.selected = selected
						if (serList.length == 0) {
							this.$dialogMethod.showMessage("此时间段内无数据记录!")
						} else {
							this.$dialogMethod.showLoading('正在加载图形。。。')
						}
						setTimeout(() => {
							this.$dialogMethod.closeLoading()
						}, 1000)
						this.$refs.vchart.setData(this.options, true)
					})
			}
		}
	}
</script>

<style scoped>
	.marginLeft {
		margin: 0 10px;
	}

	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>
